import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M183.7 118.8c-10.7-17.8-4.2-40.6 14.3-51l-20-33.4c-5.7 3.2-12.3 5.1-19.4 5.1C137.3 39.5 120 22.7 120 2H80.1c.1 6.4-1.6 12.9-5.2 18.8C64.3 38.6 40.6 44.7 22 34.3L2 67.7c5.7 3.2 10.7 7.8 14.3 13.7 10.6 17.8 4.3 40.6-14.2 51l20 33.4c5.7-3.2 12.3-5 19.3-5 21.3 0 38.5 16.7 38.6 37.3h39.9c0-6.3 1.6-12.7 5.2-18.6 10.6-17.8 34.3-23.8 52.9-13.6l20-33.4c-5.9-3.2-10.8-7.8-14.3-13.7zM100 139.7c-22.7 0-41.1-17.8-41.1-39.7 0-21.9 18.4-39.7 41.1-39.7 22.7 0 41.1 17.8 41.1 39.7 0 21.9-18.4 39.7-41.1 39.7z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}